var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { IsIn, IsInt, IsOptional, IsString, Matches, Min, } from 'class-validator';
import { LinkDescriptorDto, WorkspaceDescriptorDto } from './shared.js';
export * from './ord/agency.js';
export * from './ord/contragent.js';
export * from './ord/documents.js';
export * from './ord/marking-form.js';
export * from './ord/inn.js';
export class VkOrdCreativeInputDto extends LinkDescriptorDto {
    draftContractId;
    creativeId;
    customContractId;
    //dot-separated numbers
    //number starts from digit
    kktu;
}
__decorate([
    Min(1),
    IsInt(),
    IsOptional(),
    __metadata("design:type", Number)
], VkOrdCreativeInputDto.prototype, "draftContractId", void 0);
__decorate([
    Min(1),
    IsInt(),
    __metadata("design:type", Number)
], VkOrdCreativeInputDto.prototype, "creativeId", void 0);
__decorate([
    Min(1),
    IsInt(),
    IsOptional(),
    __metadata("design:type", Number)
], VkOrdCreativeInputDto.prototype, "customContractId", void 0);
__decorate([
    Matches(/\d+/),
    __metadata("design:type", String)
], VkOrdCreativeInputDto.prototype, "kktu", void 0);
export class UpdateVkOrdCreativeInputDto extends VkOrdCreativeInputDto {
    erid;
}
__decorate([
    IsString(),
    __metadata("design:type", String)
], UpdateVkOrdCreativeInputDto.prototype, "erid", void 0);
export class CreateVkOrdApiKeyInputDto extends WorkspaceDescriptorDto {
    vkOrdApiKey;
}
__decorate([
    Matches(/.+/),
    __metadata("design:type", String)
], CreateVkOrdApiKeyInputDto.prototype, "vkOrdApiKey", void 0);
export const OAD_LINK_TYPE_VALUES = ['agency', 'publisher'];
export class UpdateVkOrdApiKeyInputDto {
    adOrdContragentId;
    adOrdAgencyId;
    adSiteUrl;
    currentLinkType;
}
__decorate([
    IsOptional(),
    Min(1),
    IsInt(),
    __metadata("design:type", Object)
], UpdateVkOrdApiKeyInputDto.prototype, "adOrdContragentId", void 0);
__decorate([
    IsOptional(),
    Min(1),
    IsInt(),
    __metadata("design:type", Object)
], UpdateVkOrdApiKeyInputDto.prototype, "adOrdAgencyId", void 0);
__decorate([
    IsOptional(),
    Min(1),
    IsInt(),
    __metadata("design:type", String)
], UpdateVkOrdApiKeyInputDto.prototype, "adSiteUrl", void 0);
__decorate([
    IsOptional(),
    IsIn(OAD_LINK_TYPE_VALUES),
    __metadata("design:type", Object)
], UpdateVkOrdApiKeyInputDto.prototype, "currentLinkType", void 0);
//# sourceMappingURL=ord.js.map